import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { Personas } from '../components/Personas';

export function Home() {
  return (
    <main>
      <Hero />
      <Features />
      <Pricing />
      <Personas />
    </main>
  );
}
